import type { Conversation, Message } from '../../stores/inbox-store';
import { actueleKlantbronId } from './actie-bron';
import { conceptBlokkade } from './draft-gates';
import { supabase } from '../supabase';

/** De klassieke presentatie gebruikt dezelfde bron- en conceptgrenzen. */
export function classicConceptBlokkade(conversation: Conversation, messages: Message[], draft: string | null,
  draftMessageId: string | null): string | null {
  const bronId = actueleKlantbronId(messages, conversation);
  if (!bronId) return 'Herlaad het gesprek om het actuele klantbericht te controleren.';
  if (conversation.mail_werkstap?.conceptBlokkade) return conversation.mail_werkstap.conceptBlokkade;
  if (!draft) return null;
  if (draftMessageId !== bronId) return 'Het concept hoort niet bij het actuele klantbericht. Maak een nieuw concept.';
  const bron = messages.find(m => m.id === bronId);
  return conceptBlokkade({ tekst: draft, gegenereerdOp: bron?.ai_draft_generated_at || bron?.message_date });
}

/** Handmatig sluiten vereist een medewerker en gespreksversie, geen klantbron. */
export async function classicAfhandelen(conversation: Conversation): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  const response = await fetch('/api/inbox/status', {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${session?.access_token ?? ''}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ conversation_id: conversation.id, status: 'afgehandeld',
      handmatig_zonder_antwoord: true }),
  });
  const result = await response.json();
  if (!response.ok || result.conversation?.status !== 'afgehandeld') {
    throw new Error(result.error || 'Sluiten is niet bevestigd. Herlaad het gesprek.');
  }
}
